/* Project Import will be here */
import { getErrorObject } from "../../utilities/utils";
import { getMyComplaintsListApi } from "services/complaints";
/* Project Import will be here */

export const types = {
    MY_COMPLAINTS_REQUEST: "myComplaints/myComplaintsRequest",
    MY_COMPLAINTS_SUCCESS: "myComplaints/myComplaintsSuccess",
    MY_COMPLAINTS_FAILURE: "myComplaints/myComplaintsFailure",
};

let initialState = {
    isLoading: false,
    data: [],
    error: null
};

export const myComplaints = (state = initialState, action) => {
    switch (action.type) {
        case types.MY_COMPLAINTS_REQUEST:
            return { ...state, isLoading: true };
        case types.MY_COMPLAINTS_SUCCESS:
            return { ...state, ...action.payload, error: null, isLoading: false };
        case types.MY_COMPLAINTS_FAILURE:
            return { ...state, isLoading: false, error: action.payload.error };
        default:
            return state;
    }
};

/* Get complaint list to show in the card */
export const getMyComplaintsList = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.MY_COMPLAINTS_REQUEST });
        try {
            const response = await getMyComplaintsListApi();

            dispatch({
                type: types.MY_COMPLAINTS_SUCCESS,
                payload: { data: response.data.Data }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.MY_COMPLAINTS_FAILURE,
                payload: { error: message }
            });
        }
    }
};